import { Translation } from 'primeng/api'

/**
 * Libelles internes de PrimeNG (calendrier, filtres de table, boutons de
 * dialogue), par langue.
 *
 * Gardes en TypeScript plutot que dans les JSON Transloco : PrimeNG attend des
 * tableaux (noms de jours, de mois) et un objet complet d'un seul tenant, a
 * pousser via `PrimeNGConfig.setTranslation` des que la langue change, sans
 * attendre le chargement HTTP des traductions.
 *
 * Le francais est la configuration historique, reprise mot pour mot.
 */
const PRIMENG_TRANSLATIONS: Readonly<Record<'fr' | 'en', Translation>> = {
  fr: {
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    monthNames: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    startsWith: 'Commence par',
    contains: 'Contient',
    notContains: 'Ne contient pas',
    endsWith: 'Se termine par',
    equals: 'Égal à',
    notEquals: 'Différent de',
    noFilter: 'Pas de filtre',
    lt: 'Inférieur à',
    lte: 'Inférieur ou égal à',
    gt: 'Supérieur à',
    gte: 'Supérieur ou égal à',
    is: 'Est',
    isNot: "N'est pas",
    before: 'Avant',
    after: 'Après',
    clear: 'Effacer',
    apply: 'Appliquer',
    matchAll: 'Correspond à tout',
    matchAny: 'Correspond à un',
    addRule: 'Ajouter une règle',
    removeRule: 'Supprimer',
    accept: 'Oui',
    reject: 'Non',
    choose: 'Choisir',
    upload: 'Téléverser',
    cancel: 'Annuler',
    dateAfter: 'Date après',
    dateBefore: 'Date avant',
    dateIs: 'Date est',
    dateIsNot: "Date n'est pas",
    emptyFilterMessage: 'Aucun résultat.',
    emptyMessage: 'Aucun résultat.',
  },
  en: {
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    startsWith: 'Starts with',
    contains: 'Contains',
    notContains: 'Does not contain',
    endsWith: 'Ends with',
    equals: 'Equals',
    notEquals: 'Not equals',
    noFilter: 'No filter',
    lt: 'Less than',
    lte: 'Less than or equal to',
    gt: 'Greater than',
    gte: 'Greater than or equal to',
    is: 'Is',
    isNot: 'Is not',
    before: 'Before',
    after: 'After',
    clear: 'Clear',
    apply: 'Apply',
    matchAll: 'Match all',
    matchAny: 'Match any',
    addRule: 'Add rule',
    removeRule: 'Remove',
    accept: 'Yes',
    reject: 'No',
    choose: 'Choose',
    upload: 'Upload',
    cancel: 'Cancel',
    dateAfter: 'Date is after',
    dateBefore: 'Date is before',
    dateIs: 'Date is',
    dateIsNot: 'Date is not',
    emptyFilterMessage: 'No results found.',
    emptyMessage: 'No results found.',
  },
}

/** Langue inconnue : repli sur le francais, comportement historique. */
export function getPrimeNGTranslation(lang: string): Translation {
  return PRIMENG_TRANSLATIONS[lang as 'fr' | 'en'] ?? PRIMENG_TRANSLATIONS.fr
}
